import { RegistrarVisitaMasivaModule } from "./../registrar-visita-masiva/registrar-visita-masiva.module";
import { ConsultaVisitaModule } from "./../consulta-visita/consulta-visita.module";
import { RegistrarVisitaModule } from "./../registar-visita/registrar-visita.module";
import { ConfiguracionDiscapacidadModule } from "./../configuracion-discapacidad/configuracion-discapacidad.module";
import { AuthGuard } from "../../shared/guards/authGuard/auth.guard";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainframeComponent } from "./mainframe.component";
import { RegistroSalidaVisitanteModule } from "../registro-salida-visitante/registro-salida-visitante.module";
import { GenerarReporteModule } from "../generar-reporte/generar-reporte.module";
import { RegistroEntradaVisitanteModule } from "../registro-entrada-visitante/registro-entrada-visitante.module";
import { FuncionarioModule } from "../funcionario/funcionario.module";
import { consultaHistoricoModule } from "../generar-reporte/consultar-historicos/consulta-historico.module";
import { CancelarVisitaMasivaModule } from "../cancelar-agenda-masiva/cancelar-visita-masiva.module";
import { AdministrarCodigoReutilizableModule } from "../administrar-codigo-reutilizable/administrar-codigo-reutilizable.module";
import { GenerarReporteUACModule } from "../UAC/generar-reporte-UAC/generar-reporte-UAC.module";
import { AtenderCiudadanoUACModule } from "../UAC/atender-ciudadano-UAC/atender-ciudadano-UAC.module";
import { ParametrosGeneralesUACModule } from "../UAC/parametros-generales-UAC/parametros-generales-UAC.module";
import { RegistroCiudadanoUACModule } from "../UAC/registro-ciudadano-UAC/registro-ciudadano.module-uac";
import { ReporteUACModule } from "../UAC/reporte-UAC/reporte-UAC.module";
import { EditarCodigoReutilizableModule } from "../administrar-codigo-reutilizable/editar-codigo-reutilizable/editar-codigo-reutilizable.model";
import { guardarCodigoReutilizableModule } from "../administrar-codigo-reutilizable/guardar-codigo-reutilizable/guardar-codigo-reutilizable.module";
import { RegistroIngSalCodigoManualModule } from "../registrar-ing-sal-codigo-barras/registrar-ing-sal-cod-manual.module";
import { AdministrarFuncionariosModule } from "../FUNCIONARIOS/administrar-funcionarios/administrar-funcionarios.module";
import { GenerarReportesFuncionariosModule } from "../FUNCIONARIOS/generar-reportes-funcionarios/generar-reportes-funcionarios.module";
import { PlanCompensatorioModule } from "../FUNCIONARIOS/plan-compesatorio/plan-compensatorio.module";
import { RelacionDependenciaJefeModule } from "../FUNCIONARIOS/relacion-dependencia-jefe/relacion-dependencia-jefe.module";
import { GestionarIncentivoBicicletaModule } from "../FUNCIONARIOS/gestionar-incentivo-bici/gestionar-incentivo-bici.module";
import { ReporteCompensacionesModule } from "../FUNCIONARIOS/plan-compesatorio/reporte-compensaciones/reporte-compensaciones.module";
import { ConsultarFuncionarioBicicletaModule } from "../FUNCIONARIOS/consultar-funcionario-bicicleta/consultar-funcionario-bicicleta.module";
import { EliminarAgendaMasivaModule } from "../eliminar-agenda-masiva/eliminar-agenda-masiva.module";
import { AdministrarAgendamientoVirtualModule } from "../administrar-agendamiento-virtual/administrar-agendamiento-virtual.module";
import { ListarDependenciasFuncionariosModule } from "../listar-dependencias/listar-dependencias-funcionarios.module";
import { BusquedaFuncionarioModule } from "../busqueda-funcionario/listar-dependencias-funcionarios.module";
import { RegistrarCargaIntentarioModule } from "../registrar-carga-inventario/registrar-carga-inventario.module";
import { AdministrarParametrosTotemModule } from "../administrar-parametros-totem/administrar-parametros-totem-component.module";

const ROUTES_MAIN: Routes = [
  {
    path: "",
    component: MainframeComponent,
    children: [
      {
        path: "",
        loadChildren: () => ConsultaVisitaModule,
      },
      {
        path: "registro-salida-visitante",
        loadChildren: () => RegistroSalidaVisitanteModule,
        canActivate: [AuthGuard],
      },
      {
        path: "configuracion-discapacidad",
        loadChildren: () => ConfiguracionDiscapacidadModule,
        canActivate: [AuthGuard],
      },
      {
        path: "registrar-nueva-visita",
        loadChildren: () => RegistrarVisitaModule,
        canActivate: [AuthGuard],
      },
      {
        path: "registro-entrada-visitante",
        loadChildren: () => RegistroEntradaVisitanteModule,
        canActivate: [AuthGuard],
      },
      {
        path: "generar-reporte-component",
        loadChildren: () => GenerarReporteModule,
        canActivate: [AuthGuard],
      },
      {
        path: "registro-visita-masiva",
        loadChildren: () => RegistrarVisitaMasivaModule,
        canActivate: [AuthGuard],
      },
      {
        path: "registro-visita-masiva",
        loadChildren: () => RegistrarVisitaMasivaModule,
        canActivate: [AuthGuard],
      },
      {
        path: "registro-carga-inventario",
        loadChildren: () => RegistrarCargaIntentarioModule,
        canActivate: [AuthGuard],
      },
      {
        path: "consultar-historico",
        loadChildren: () => consultaHistoricoModule,
        canActivate: [AuthGuard],
      },
      {
        path: "funcionario",
        loadChildren: () => FuncionarioModule,
        canActivate: [AuthGuard],
      },
      {
        path: "registro-activo-fijo",
        loadChildren: () => FuncionarioModule,
        canActivate: [AuthGuard],
      },
      {
        path: "cancelar-visita-masiva",
        loadChildren: () => CancelarVisitaMasivaModule,
        canActivate: [AuthGuard],
      },
      {
        path: "eliminar-agenda-masiva",
        loadChildren: () => EliminarAgendaMasivaModule,
        canActivate: [AuthGuard],
      },
      {
        path: "administrar-codigos-reutilizable",
        loadChildren: () => AdministrarCodigoReutilizableModule,
        canActivate: [AuthGuard],
      },
      {
        path: "administrar-agendamiento-virtual",
        loadChildren: () => AdministrarAgendamientoVirtualModule,
        canActivate: [AuthGuard],
      },
      {
        path: "administrar-parametros-totem",
        loadChildren: () => AdministrarParametrosTotemModule,
        //canActivate: [AuthGuard],
      },
      {
        path: "listar-dependencias-funcionarios",
        loadChildren: () => ListarDependenciasFuncionariosModule,
        canActivate: [AuthGuard],
      },
      {
        path: "busqueda-funcionarios",
        loadChildren: () => BusquedaFuncionarioModule,
        canActivate: [AuthGuard],
      },
      {
        path: "editar-codigos-reutilizable",
        loadChildren: () => EditarCodigoReutilizableModule,
        canActivate: [AuthGuard],
      },
      {
        path: "guardar-codigos-reutilizable",
        loadChildren: () => guardarCodigoReutilizableModule,
        canActivate: [AuthGuard],
      },
      {
        path: "generar-reporte-UAC",
        loadChildren: () => GenerarReporteUACModule,
        canActivate: [AuthGuard],
      },
      {
        path: "atender-ciudadano-UAC",
        loadChildren: () => AtenderCiudadanoUACModule,
        canActivate: [AuthGuard],
      },
      {
        path: "parametros-generales-UAC",
        loadChildren: () => ParametrosGeneralesUACModule,
        canActivate: [AuthGuard],
      },
      {
        path: "registro-ciudadano-UAC",
        loadChildren: () => RegistroCiudadanoUACModule,
        canActivate: [AuthGuard],
      },
      {
        path: "reporte-UAC",
        loadChildren: () => ReporteUACModule,
        canActivate: [AuthGuard],
      },
      {
        path: "captura-manual-cod-barras",
        loadChildren: () => RegistroIngSalCodigoManualModule,
        canActivate: [AuthGuard],
      },
      {
        path: "administrar-funcionarios",
        loadChildren: () => AdministrarFuncionariosModule,
        canActivate: [AuthGuard],
      },
      {
        path: "generar-reportes-funcionarios",
        loadChildren: () => GenerarReportesFuncionariosModule,
        canActivate: [AuthGuard],
      },
      {
        path: "plan-compensatorio",
        loadChildren: () => PlanCompensatorioModule,
        canActivate: [AuthGuard],
      },
      {
        path: "dependencia-jefe",
        loadChildren: () => RelacionDependenciaJefeModule,
        canActivate: [AuthGuard],
      },
      {
        path: "incentivoBicicleta",
        loadChildren: () => GestionarIncentivoBicicletaModule,
        canActivate: [AuthGuard],
      },
      {
        path: "reporte-compensaciones",
        loadChildren: () => ReporteCompensacionesModule,
        canActivate: [AuthGuard],
      },
      {
        path: "consultar-funcionario-bicicleta",
        loadChildren: () => ConsultarFuncionarioBicicletaModule,
        canActivate: [AuthGuard],
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(ROUTES_MAIN)],
  exports: [RouterModule],
})
export class MainFrameRoutingModule {}
